import React from 'react';

import styles from './CurrentDue.module.css';
import CurrentPaymentMethod from './CurrentPaymentMethod';
import AutopayIcon from './AutopayIcon';

import SubBox from 'common/SubBox';
import Link from 'common/Link';
import { formatDate } from 'helpers/formatters';
import { DUE_DATE_FORMAT } from 'app_constants';
import { renewSubscriptions } from 'app/routes';

export const dueDate = (currentCycle, daysLeftInCycle) => {
  if (daysLeftInCycle === 0) {
    return 'due today';
  }
  else if (currentCycle) {
    return 'due ' + formatDate(currentCycle.end_date, DUE_DATE_FORMAT);
  }
  else {
    return null;
  }
}

const UpcomingBill = ({ paymentMethod, user, renewalPurchase, daysLeftInCycle, currentCycle }) => {
  if (!renewalPurchase) { return null; }

  return (
    <React.Fragment>
      <span className={styles.totalDue}>
        ${renewalPurchase.cost.total}
      </span>
      {' '}
      <span className={styles.dueDate}>
        {dueDate(currentCycle, daysLeftInCycle)}
      </span>
      <CurrentPaymentMethod paymentMethod={paymentMethod} />
      <SubBox>
        <AutopayIcon enabled={user.autopay_enabled} />
        <Link to={renewSubscriptions()} className={styles.payNow}>
          View Bill
        </Link>
      </SubBox>
    </React.Fragment>
  )
};

export default UpcomingBill;
